var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"guestproductcontentdownloader-view"}},[_c('GuestProductContentDownloader',{attrs:{"orderId":_vm.orderId,"oTP":_vm.oTP}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }